module.exports = __webpack_public_path__ + "img/实验室净化.b49c3382.jpg";